import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumUkBeerDutySection implements BaseEnumType {
  private static allValues: EnumUkBeerDutySection[] = []; // make sure this is top-most
  
  public static none = new EnumUkBeerDutySection(0, "None", "enum_uk_beer_duty_section_none");
  public static standardRate = new EnumUkBeerDutySection(1, "StandardRate", "enum_uk_beer_duty_section_standard_rate");
  public static lowStrength = new EnumUkBeerDutySection(2, "LowStrength", "enum_uk_beer_duty_section_low_strength");
  public static lowerRate = new EnumUkBeerDutySection(3, "LowerRate", "enum_uk_beer_duty_section_lower_rate");
  public static variableRate = new EnumUkBeerDutySection(4, "VariableRate", "enum_uk_beer_duty_section_variable_rate");
  public static highStrengthBeer = new EnumUkBeerDutySection(5, "HighStrengthBeer", "enum_uk_beer_duty_section_high_strength_beer");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumUkBeerDutySection.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumUkBeerDutySection.none; }
  public isStandardRate() { return this === EnumUkBeerDutySection.standardRate; }
  public isLowStrength() { return this === EnumUkBeerDutySection.lowStrength; }
  public isLowerRate() { return this === EnumUkBeerDutySection.lowerRate; }
  public isVariableRate() { return this === EnumUkBeerDutySection.variableRate; }
  public isHighStrengthBeer() { return this === EnumUkBeerDutySection.highStrengthBeer; }

  public static getValues(): readonly EnumUkBeerDutySection[] {
    return EnumUkBeerDutySection.allValues;
  }

  public static getValuesExcept0(): readonly EnumUkBeerDutySection[] {
    return EnumUkBeerDutySection.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumUkBeerDutySection {
    const found = EnumUkBeerDutySection.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumUkBeerDutySection - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumUkBeerDutySection): EnumUkBeerDutySection {
    const found = name ? EnumUkBeerDutySection.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumUkBeerDutySection - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumUkBeerDutySection>): boolean {
    return this.key === other?.key;
  }
}